import emailjs from "@emailjs/browser";
import React, { useRef } from "react";
import { Zoom } from "react-reveal";
import Flash from "react-reveal/Flash";
import RubberBand from "react-reveal/RubberBand";
import swal from "sweetalert";
// import contact data
import { contact } from "../data";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    if(e.target){
      emailjs
      .sendForm(
        "service_bjy2bzr",
        "template_g7jk9vl",
        e.target,
        "HpFxxw-8_8fm-SaXV"
      )
      .then(
        (result) => {
          swal("Successfull", "You Send an Email!", "success");
          e.target.reset();
        },
        (error) => {
          swal("OPPSS...", "Email not Send!", "error");
        }
      );
    }
  };

  return (
    <section
      className="section bg-gradient-to-r from-[#24263b] to-[#293068]"
      id="contact"
    >
      <div className="container mx-auto">
        <RubberBand>
          <div className="flex flex-col items-center text-center">
            <h2 className="section-title before:content-contact relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block">
              Contact me
            </h2>
            <p className="subtitle">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga
              veniam labore nisium illum cupiditate reiciendis a numquam
            </p>
          </div>
        </RubberBand>
        <div className="flex flex-col lg:gap-x-8 lg:flex-row">
          <div className="flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2">
            {contact.map((item, index) => {
              const { icon, title, subtitle, phone, description } = item;
              return (
                <div className="flex flex-col lg:flex-row gap-x-4" key={index}>
                  <div
                    className="text-accent rounded-sm w-14 h-14 flex items-start 
                  justify-center mt-2 mb-4 lg:mb-0 text-2xl"
                  >
                    {icon}
                  </div>
                  <Flash>
                    <div>
                      <h4 className="font-body text-xl mb-1">{title}</h4>
                      <p className="mb-1 text-paragraph">{subtitle}</p>
                      <a
                        target="_blank"
                        href="tel:01636090316"
                        rel="noopener noreferrer"
                        className=""
                      >
                        <p className="text-accent text-xl font-normal ">
                          {phone}
                        </p>
                      </a>
                      <a
                        target="_blank"
                        href="mailto:ashrafulislam1659@gmail.com"
                        rel="noopener noreferrer"
                        className=""
                      >
                        <p className="text-accent text-xl font-normal ">
                          {description}
                        </p>
                      </a>
                    </div>
                  </Flash>
                </div>
              );
            })}
          </div>
          <Zoom top>
            <form
              ref={form}
              onSubmit={sendEmail}
              className="space-y-8 w-full max-w-[780px]"
            >
              <div className="flex gap-8">
                <input
                  required
                  name="user_name"
                  className="input"
                  type="text"
                  placeholder="Your name"
                />
                <input
                  required
                  name="user_email"
                  className="input"
                  type="email"
                  placeholder="Your email"
                />
              </div>
              <input
                required
                name="subject"
                className="input"
                type="text"
                placeholder="Subject"
              />
              <textarea
                required
                name="message"
                className="textarea"
                placeholder="Your message"
              ></textarea>
              <button
                type="submit"
                className="btn btn-lg bg-accent hover:bg-secondary-hover"
              >
                Send message
              </button>
            </form>
          </Zoom>
        </div>
      </div>
    </section>
  );
};

export default Contact;
